// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UJjxCCVDVfneYoJc_wyN{border-radius:0 !important}.UJjxCCVDVfneYoJc_wyN:hover{color:#fff}`, "",{"version":3,"sources":["webpack://./src/pages/PendingSams/components/PendingSamsBodyTable/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,0BAAA,CACA,4BACE,UAAA","sourcesContent":[".button\n  border-radius: 0 !important\n  &:hover\n    color: #fff\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `UJjxCCVDVfneYoJc_wyN`
};
export default ___CSS_LOADER_EXPORT___;
